// https://github.com/bfred-it/object-fit-images
// https://github.com/scottjehl/picturefill
// https://isotope.metafizzy.co
// https://idiotwu.github.io/smooth-scrollbar/

import throttle from 'lodash/throttle'

require('intersection-observer')
window.jQuery = window.$ = require('jquery')

//require('popper.js/dist/umd/popper.min.js')
//require('bootstrap/js/dist/util.js')
//require('bootstrap/js/dist/collapse.js')
//require('bootstrap/js/dist/scrollspy.js')
require('bootstrap/js/dist/modal.js')
require('bootstrap/js/dist/tab.js')

require('./ScrollConverterWindow')

/* IE11 Polifills */
// https://barba.js.org/docs/getstarted/browser-support/
require('es6-promise').polyfill(); // for barbajs, webpack dynamic import
// https://github.com/zloirock/core-js
// import 'core-js'
import 'core-js/features/array';
import 'core-js/features/object';
import 'core-js/features/number';
import 'core-js/features/dom-collections/for-each'
import 'core-js/web/dom-collections'
import 'core-js/features/dom-collections/iterator'
/* IE11 Polifills */

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import appUtils from './modules/app_utils'
import utils from './modules/utils'
import iocallback from './modules/iocallback'
import carousel from './modules/carousel'
import timeline from './modules/timeline'
import fontanimation from './modules/fontanimation'
import toggleclassObserver from './modules/toggleclass_observer'
import tip from './modules/tip';
import barbaSetup from './modules/barba_setup';
import svgInline from './modules/svg_inline'
import sections from './modules/sections'

require('./modules/modernizr')

/*
 * Select "got to url on change"
 */
const selectChangeLocation = function(e) {
  /*
  let optionSelected = $("option:selected", this);
  let url = optionSelected.val(); //.text();
  */
  let url = $(this).val()
  if (url) {
    //window.location.href = url
    goBarba(url)
  }
}

const barbaChangeLocation = function(e, url) {
  if (url) {
    //window.location.href = url
    goBarba(url)
  }
}

const modalIframeClickHandler = function(e){
  let iframeSrc = $(this).attr('data-open-iframe')
  if (iframeSrc && typeof(appUtils.openIframeModal) === 'function') {
    e.preventDefault()
    appUtils.openIframeModal(iframeSrc)
  }
}

const shareUrlFormat = function(str){
    var url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    str = str.replace(/%url%/g, encodeURIComponent(url));
    str = str.replace(/%title%/g, $('title').text());
    return str;
}

const scrollToHash = function(hash) {
  appUtils.scrollTo(hash)
  // window.location.hash = hash; // whold remove scrollTo animation
}

let videoPlaying = null
const pageViewInit = function(nextContainer){
  $('a:external').attr('target', '_blank').attr('rel', 'noopener').attr('data-barba-prevent', 'self');
  carousel.init()
  svgInline.init()
  timeline.init()
  fontanimation.init()
  toggleclassObserver.init()
  iocallback.init()

  sections.init()

  appUtils.lazyUpdate()
  appUtils.$window.trigger('app:page_init')
}

const pageViewDestroy = function(currentContainer){
  toggleclassObserver.destroy()

  carousel.destroy()
  svgInline.destroy()
  timeline.destroy()
  fontanimation.destroy()
  iocallback.destroy()

  sections.destroy()

  if (videoPlaying) {
    videoPlaying.pause()
  }
}

$(document)
  .ready(function(){
    //Object-fit polyfill
    //https://github.com/bfred-it/object-fit-images
    if(typeof(objectFitImages)==='function'){
      objectFitImages(null, {watchMQ: true})
      //objectFitImages()
    }

    // lazy load images in isotope items
    appUtils.$window.on('more:items-appended', appUtils.lazyUpdate)

    appUtils.$window.on('sub-header-out', function(){
      $('#sub-header--fixed').addClass('show');
    })
    appUtils.$window.on('sub-header-in', function(){
      $('#sub-header--fixed').removeClass('show');
    })

    if(appUtils.mainContentForTouch){
      appUtils.$html.addClass('scroll-main-content')
    }

    // disable browser scroll restoration
    // https://github.com/barbajs/barba/issues/158
    // https://barba.js.org/docs/advanced/recipes/#Scroll-position
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    // https://github.com/verlok/lazyload#-api
    // masonry.destroy()
    appUtils.lazyLoadInstanceInit()

    let currentScroll = 0
    let scrollMax = 0
    const windowScroll = function(){
      const scrollPos = appUtils.$window.scrollTop()
      if(scrollPos < 180) {
        appUtils.$body.removeClass('is-scrolled')
      } else {
        appUtils.$body.addClass('is-scrolled')
      }
      if (scrollPos > currentScroll) {
        appUtils.$body.removeClass('is-scrolled-up')
      } else if (scrollPos < currentScroll) {
        appUtils.$body.addClass('is-scrolled-up')
      }
      currentScroll = scrollPos
      if (Math.abs(currentScroll - ScrollTrigger.maxScroll(window)) < 10) {
        // footer animation
        appUtils.triggerEvent('bg-footer')
      }
    }
    const resizeHandler = function() {
      // scrollMax = document.documentElement.scrollHeight - document.documentElement.clientHeight
      windowScroll()
			document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px')
		}
    const resizeHandlerThrottle = throttle(resizeHandler, 200)
    const windowScrollThrottle = throttle(windowScroll, 200)

    resizeHandler()
    appUtils.$window
			.resize(resizeHandlerThrottle)
			.scroll(windowScrollThrottle)

    sections.appInit()
    tip.appInit()

    barbaSetup.initLoader()
    barbaSetup.initBarba(pageViewInit, pageViewDestroy)

    appUtils.$window.on('barbaChangeLocation', barbaChangeLocation)


    appUtils.$window.on('bg-footer', function(e){
      appUtils.bgLogoTo({left: '0%', top: '80%', opacity: 1})
    })
    appUtils.$window.on('bg-center', function(e){
      appUtils.bgLogoTo({left: '50%', top: '20%', opacity: 1})
    })
    appUtils.$window.on('bg-left', function(e){
      appUtils.bgLogoTo({left: '-20%', top: '20%', opacity: 1})
    })
    appUtils.$window.on('bg-right', function(e){
      appUtils.bgLogoTo({left: '100%', top: '20%', opacity: 1})
    })
    appUtils.$window.on('bg-rightbottom', function(e){
      appUtils.bgLogoTo({left: '100%', top: '60%', opacity: 1})
    })
    appUtils.$window.on('bg-leftbottom', function(e){
      appUtils.bgLogoTo({left: '-20%', top: '60%', opacity: 1})
    })
    appUtils.$window.on('bg-alphazero', function(e){
      appUtils.bgLogoTo({opacity: 0})
    })
    appUtils.$window.on('image_loaded', function(e, el){
      /*
      * Add 'loaded' css class to picture tag
      */
      const $el = $(el)
      const $parent = $el.parent()
      if ($parent.is('picture')) {
        $parent.addClass('loaded')
      }
    })

    appUtils.$window.trigger('bg-alphazero')

    appUtils.$window.on('add-inview-section', function(e, entry){
      if ($(entry.target).is('.section--light')) {
        appUtils.$body.addClass('page-bg-light')
      }
      if ($(entry.target).is('#gallery')) {
        appUtils.$body.addClass('is-gallery-in')
      }
    })
    appUtils.$window.on('remove-inview-section', function(e, entry){
      if ($(entry.target).is('.section--light')) {
        appUtils.$body.removeClass('page-bg-light')
      }
      if ($(entry.target).is('#gallery')) {
        appUtils.$body.removeClass('is-gallery-in')
      }
    })

    /*
    * open modal or scroll to hash after pageViewInit
    */
    setTimeout(()=>{
      if(window.location.hash){
        let hashValue = window.location.hash.substr(1);
        if($('.modal-' + hashValue).length){
          $('.modal-' + hashValue).first().modal('show');
        } else {
          scrollToHash(window.location.hash)
        }
      }
    }, 900)

    // Listen Shown Modal Event and update caorusel size
    // appUtils.$window.on('shown.bs.modal', function (e) {
    //   setTimeout(() => {
    //     carousel.update()
    //   }, 100)
    // })
  })
  .on('click', 'a', function(e) {

      appUtils.$html.removeClass(appUtils.navigationToggleClass)
      // Open modals to be closed?
      $('.modal').modal('hide')

      var href = $(this).attr('href'); //this.href returns the complete url#something
      // href starts with # : is it an anchor?
      if( /^#/.test(href) && !$(this).attr('data-toggle')) { // if (this.hash) {
        const hash = this.hash
        if(hash) {
          scrollToHash(hash)
        }
        e.preventDefault() //defaults(e);
      }

      // prevent reload on same link
      if(href === window.location.href) {
        e.preventDefault();
        e.stopPropagation();
      }
  })
  .on('click', '[data-toggle-overlay]', function(e) {
    e.preventDefault()
    // $(this).closest('.col').toggleClass('is-open')
    appUtils.$body.toggleClass('is-overlay-open')
    // setta corretta slide
    var index = $(this).closest('.col').index()
    if (index > 0) {
      $(this).closest('.section').find('[data-swiper]').data('carousel-instance').swpInstance.slideTo(index);
    }
  })
  // .on('mousemove', '[data-image-move]', function(e) {
  //   var height = appUtils.$window.height();
  //   var width = appUtils.$window.width();
  //
  //   if (height > width) {
  //     var delta = (height - width)
  //     var move = e.offsetX / width * delta
  //     $(this).css('background-position-x', -move + "px");
  //   } else {
  //     var delta = (width - height)
  //     var move = (e.offsetY) / height * delta
  //     $(this).css('background-position-y', -move + "px");
  //   }
  // })
  .on('click', '.collection__arrow', function(e) {
    e.preventDefault()
    var action = $(this).parent().attr('class').substr(19);
    var current = $(this).closest('.collection').find('.is-open');
    if (action == 'prev') {
      current.removeClass('is-open')
      if (current.prev('.col').length) {
        current.prev('.col').addClass('is-open')
      } else {
        current.siblings('.col').last().addClass('is-open')
      }
    } else if (action == 'next') {
      current.removeClass('is-open')
      if (current.next('.col').length) {
        current.next('.col').addClass('is-open')
      } else {
        current.siblings('.col').first().addClass('is-open')
      }
    }
  })
  .on('mouseenter', '.colors .swiper-pagination-bullet', function(e) {
    if (!appUtils.isTouch()) {
      $(this).click()
    }
  })
  /*
  .on('click', '[data-open-window]', function(e){
    e.preventDefault();
    if($(this).attr('data-urlpattern')){
      const formatted = shareUrlFormat($(this).attr('data-urlpattern'));
      window.open(formatted, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=440,width=600');
    }
  })
  */
  /*
  .on('click', '[data-share-toggle]', function(e){
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
    e.preventDefault();

    var url = window.location.href
    const canonicalElement = document.querySelector('link[rel=canonical]')
    if(canonicalElement !== undefined) {
      url = canonicalElement.href
    }
    const pageTitle = $('title').text()
    const pageDescription = $('meta[name="description"]').attr('content')
    const shareData = {
      title: pageTitle,
      text: pageDescription,
      url: url,
    }
    if(typeof navigator.share !== 'undefined'){
      navigator.share(shareData)
        .then(function() { console.log("Share success!"); })
        .catch(function() { console.log("Share failure!"); })
    } else {
      const $parent = $(this).parent()
      $parent.toggleClass('share-tool-active')
      if ($parent.hasClass('share-tool-active')) {
        $(document).on('click', shareToggleOnDocumentClick)
      }
    }
  })
  */
  .on('click', '[data-open-iframe]', modalIframeClickHandler)
  .on('click', '[data-menutoggle]', function(e){
    appUtils.$html.toggleClass(appUtils.navigationToggleClass)
  })
  .on('click', '[data-goto-url]', function(e){
    goBarba($(this).attr('data-goto-url'))
  })
  .on('click', '[data-show]', function(e){
    e.preventDefault()
    const $el = $(this)
    $el.hide()
    const $target = $($el.attr('data-show'))
    if ($target.length) {
      $target.show()
    }
  })
  .on('click', '[data-item-more]', function(e){
    e.preventDefault()
    const $el = $(this)
    $el.toggleClass('open')
  })
  .on('click', 'video[data-video-play]', function(e){
    // https://www.w3schools.com/tags/ref_av_dom.asp
    const target = e.target
    if (target.paused) {
      target.play()
      videoPlaying = target
    } else {
      target.pause()
      videoPlaying = null
    }
  })
  // .on('change', '[data-change-location]', selectChangeLocation)
